<template>
    <div class="zhitongche-wrap">
        <div class="zhitongche" style="position: relative;">
            <div class="hejie">——行业预警——</div>

            <swiper :options="swiperOptionF">
                <swiper-slide class="swiper-list" :key="index" v-for="(item, index) in train">
                    <div class="img-wrap" :title="item.detail">
                        <div @click="toArticle(item.id)">
                            <img class="swiper-img" :src="item.logo">
                            <span style="display: block" v-text="item.title"></span>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="swiper-button-prev change-btn" slot="button-prev"
                 style="margin-left:-19px;z-index:999;position: absolute;top:130px;left:26px;width:30px; height:48px;">
            </div>

            <div class="swiper-button-next change-btn-2" slot="button-next"
                 style="margin-left:-19px;z-index:999;position: absolute;top:130px;right:11px;">
            </div>
        </div>
    </div>
</template>

<script>
  import {swiper, swiperSlide} from 'vue-awesome-swiper'

  export default {
    name: "zhitongche",
    components: {
      swiper, swiperSlide,
    },
    data() {
      return {
        train: '',
        swiperOptionF: {
          slidesPerView: 5,
          spaceBetween: 30,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.change-btn-2',
            prevEl: '.change-btn'
          },
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
          },

        }
        // swiperOptionA: {
        //   slidesPerView: 5,
        //   spaceBetween:
        //     30,
        //   slidesPerGroup:
        //     3,
        //   loop:
        //     true,
        //   loopFillGroupWithBlank:
        //     true,
        //   pagination:
        //     {
        //       el: '.swiper-pagination',
        //       clickable:
        //         true
        //     }
        //   ,
        //   speed: 50000,
        //   autoplay:
        //     {
        //       delay: 0,
        //       stopOnLastSlide:
        //         false,
        //       disableOnInteraction:
        //         false,
        //     },
        //   navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl:
        //       '.swiper-button-prev'
        //   }
        // },
      }
    },
    methods: {
      toArticle(id) {
        this.$router.push({path: '/HejieDaren', query: {artId: id, title: '行业预警'}})
      },
      getTrain() {
        this.$get("/index/index/through_train",).then((res) => {
          if (res.code === 0) {
            this.train = res.data.train
          }
        }).catch((err) => {
          console.log(err)
        })
      },
    },
    mounted() {
      this.getTrain()
    }
  }
</script>

<style scoped lang="less">
    .zhitongche-wrap {
        margin: 0 auto;
    }

    .zhitongche {
        max-width: 1200px;
        max-height: 255px;
        background: #ecf3ff;
        padding: 22px 45px;

        /deep/ .swiper-wrapper {
            transition-timing-function: linear !important;
        }

    }

    .hejie, .daren {
        text-align: center;
        height: 26px;
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: rgba(41, 75, 127, 1);
        line-height: 26px;
        margin: 0 0 16px 0;
    }

    .img-wrap {
        text-align: center;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(51, 51, 51, 1);
        line-height: 19px;
        margin: 0 10px;
        cursor:pointer;
    }

    .swiper-img {
        width: 210px;
        height: 140px;
        object-fit: cover;
    }

    .swiper-button-prev {
        background-image: url('../assets/image/arrow_left.png')
    }

    .swiper-button-next {
        background-image: url('../assets/image/arrow_right.png')

    }

    .swiper-container {
        right: 7px;
    }
</style>
